import { createLazyFileRoute } from "@tanstack/react-router";

import { NewTubePage } from "@/features/admin/routes/TubeNew";

export const Route = createLazyFileRoute("/_auth/admin/tubes/new")({
  component: NewTubePage,
});
